import { useCriteriaFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts';

export const useResetCriteriaErrors = () => {
  const { resetErrorsFromFieldPath } = useQueryErrorStateContext();
  const fieldPath = useCriteriaFieldPath();
  return () => resetErrorsFromFieldPath(fieldPath);
};
